import SocketClient from './SocketClient';
import store from '../redux/store';
import { receiveUserData } from '../redux/actions/authActions';
import { GET_REFERRER_SUCCESS, SOCKET_CONNECTED, SOCKET_DISCONNECT } from '../redux/actions/actionsType';
export * from './SocketClient'

const instanceSocketClient = new SocketClient();

export const getInstanceSocketClient = () => {
  if (!instanceSocketClient.isConnected) {
    let token = localStorage.getItem("token")
    console.log("🔑 [socket] token from localStorage:", token ? `EXISTS (${token.substring(0, 20)}...)` : "MISSING ❌")
    if (token) {
      instanceSocketClient.init("", token)
    }
  }
  return instanceSocketClient
}

export const SocketListeners = (socket) => {

  console.log("SocketListeners", socket)
  // socket.on('update-jobs', function (data) {
  //     console.log("new-jobs", data)
  //     store.dispatch({ type: JOB_UPDATE_SOCKET, job: data })

  // });

  // socket.on('new-jobs', function (data) {
  //     console.log("newJobs", data)
  //    // store.dispatch(getjobsFromApi())
  // });
  socket.on("connection", (args) => {
    console.log("socket->connection  ", args)
  })
  socket.on("connected", (res) => {
    console.log("socket->connected", res)
    // console.log("connected")
    store.dispatch({ type: SOCKET_CONNECTED })
  })

  socket.on("disconnected", (res) => {
    console.log("socket->disconnected", res)
    // console.log("connected")
    store.dispatch({ type: SOCKET_DISCONNECT })
  })
  socket.on("disconnect", (res) => {
    console.log("socket->disconnect", res)
    // console.log("connected")
    store.dispatch({ type: SOCKET_DISCONNECT })
  })

  
  socket.on("connectedSaved", (res) => {
    console.log("connectedSaved", res)
  })

  socket.on("asyncAccount", (res) => {
    console.warn("socket->asyncAccount")
    if (res) {
      receiveUserData(res)
    }

  })

  socket.on('updateReferrer', (res) => {
    if (res) {
      store.dispatch({ type: GET_REFERRER_SUCCESS, referrer: res })
    }

    console.warn("updateReferrer", res)
  })


}

export default instanceSocketClient;
export { instanceSocketClient }
